// TODO: change inital state after old or new brand page will be settled in
export const initialState = {}

export const set = (state, payload) => payload
